import React from 'react';
import ReactGA from 'react-ga';
import ReactMarkdown from 'react-markdown/with-html';

import text1 from './RealTimeAvailabilityText1.js';
import text2 from './RealTimeAvailabilityText2.js';
import text3 from './RealTimeAvailabilityText3.js';
import text4 from './RealTimeAvailabilityText4.js';
import BENEFIT_1 from './API_Icon_RealTime_Benefit_1.png';
import BENEFIT_2 from './API_Icon_RealTime_Benefit_2.png';
import BENEFIT_3 from './API_Icon_RealTime_Benefit_3.png';
import Prerequisite from './API_RealtimeAvailability_Prerequisite@2x.png';

import './realTimeAvailability.scss'

class RealTimeAvailabilityComponent extends React.Component {
    componentDidMount() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.set({ title: 'MMS Integrations Guides Page' });
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        return <div className="real-time-component">
            <ReactMarkdown escapeHtml={false} children={text1} />
            <div className='key-benefits'>
                <div className='box'><img src={BENEFIT_1} alt='benefit_1' /><br />Integrate real-time equipment usage into your <span className='alt'>native facility app</span></div>
                <div className='box'><img src={BENEFIT_2} alt='benefit_2' /><br />Create a <span className='alt'>microsite</span> displaying real-time availability of your connected cardio equipment</div>
                <div className='box'><img src={BENEFIT_3} alt='benefit_3' /><br />See the <span className='alt'>time elapsed</span> for workouts in progress</div>
            </div>
            <ReactMarkdown escapeHtml={false} children={text2} />
            <div className='prereq'>
                <img src={Prerequisite} alt='Prerequisite' />
            </div>
            <ReactMarkdown escapeHtml={false} children={text3} />
            <table>
                <thead>
                    <tr>
                        <th>Parameter Name</th>
                        <th>Parameter Description</th>
                        <th>Example</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>subType</td>
                        <td>The subscription notification type</td>
                        <td>Possible values:
                            <ul>
                                <li>LFUserLoggedIn</li>
                                <li>LFUserWorkoutStarted</li>
                                <li>LFUserWorkoutData</li>
                                <li>LFUserWorkoutEnded</li>
                                <li>LFUserLoggedOut</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>timestamp</td>
                        <td>Timestamp of the event</td>
                        <td>2020-02-24T20%3A20%3A15.895Z</td>
                    </tr>
                    <tr>
                        <td>access_token</td>
                        <td>The Life Fitness user's access-token</td>
                        <td>xyz123......</td>
                    </tr>
                    <tr>
                        <td>device</td>
                        <td>Body serial of the equipment</td>
                        <td>HHT-902902</td>
                    </tr>
                    <tr>
                        <td>facilityId</td>
                        <td>Life Fitness facility id of the equipment</td>
                        <td>20</td>
                    </tr>
                    <tr>
                        <td>activityId</td>
                        <td>Numeric identifier of the equipment type</td>
                        <td>1</td>
                    </tr>
                </tbody>
            </table>
            <ReactMarkdown escapeHtml={false} children={text4} />
        </div>
    }
}

export default RealTimeAvailabilityComponent;



// WEBPACK FOOTER //
// ./src/components/guides/RealTimeAvailability/RealTimeAvailabilityComponent.js